import { useCallback, useEffect } from 'react';

export default function IncidentDecorator(props) {
  /* eslint-disable react/prop-types */
  const {
    values,
    form: { change }
  } = props;
  const { date, time, datetime } = values;
  /* eslint-enable */

  const setDatetime = useCallback(() => {
    const newDateTime = date && time ? new Date(`${date} ${time}`) : undefined;

    change('datetime', newDateTime);
  }, [change, date, time]);

  useEffect(() => {
    if (date && time && !datetime) {
      setDatetime();
    }
  });

  useEffect(() => {
    setDatetime();
  }, [setDatetime]);

  return null;
}
